export const SITES = {
  Stadswonen: 'stadswonen-website',
  Woonstad:  'woonstad-website'
} as const;

export type SitesType = typeof SITES[keyof typeof SITES];
